export const prefix = 'oyml:';
export var FieldNames;
(function (FieldNames) {
    FieldNames["optimizationObjective"] = "oyml:optimizationObjective";
})(FieldNames || (FieldNames = {}));
export var BusinessObjectiveOptions;
(function (BusinessObjectiveOptions) {
    BusinessObjectiveOptions["ClickThroughRate"] = "ctr";
    BusinessObjectiveOptions["ConversionRate"] = "cvr";
    BusinessObjectiveOptions["RevenuePerOrder"] = "revenue-per-order";
})(BusinessObjectiveOptions || (BusinessObjectiveOptions = {}));
export const defaultFormValues = {
    [FieldNames.optimizationObjective]: BusinessObjectiveOptions.ClickThroughRate,
};
export const labelByFieldOption = {
    [BusinessObjectiveOptions.ClickThroughRate]: 'RECS_MODEL_STEP_OTHERS_YOU_MAY_LIKE_CLICK_THROUGH_RATE',
    [BusinessObjectiveOptions.ConversionRate]: 'RECS_MODEL_STEP_OTHERS_YOU_MAY_LIKE_CONVERSION_RATE',
    [BusinessObjectiveOptions.RevenuePerOrder]: 'RECS_MODEL_STEP_OTHERS_YOU_MAY_LIKE_REVENUE_PER_SESSION',
};
